"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = compareByReadingOrder;
function compareByReadingOrder(layerA, layerB) {
  // Ensures that the shifted layers (right side) come after the non-shifted layers (left side).
  // If this printable does not have a composite design, this will do nothing.
  if (layerA.id.includes('--SHIFTED') === layerB.id.includes('--SHIFTED')) {
    return compareByCartesianCoordinates(layerA, layerB);
  } else if (layerA.id.includes('--SHIFTED') && !layerB.id.includes('--SHIFTED')) {
    return 1;
  } else {
    return -1;
  }
}
/**
 * Compares two given layers based on their cartesian coordinates. Indicates where layer A is located
 * in relation to layer B. Another way to think of this in terms of 'reading order',
 * that is: top-left -> bottom right.
 *
 * @param layerA Layer 1 to compare
 * @param layerB Layer 2 to compare
 * @returns Integer indicating order of layer A in relation to layer b on a cartesian plane.
 *  -> 1 = layer A is located after layer B.
 *  -> 0 = layer A and layer B share the same location on the cartesian plane.
 *  -> -1  = layer A is behind layer B.
 */
function compareByCartesianCoordinates(layerA, layerB) {
  const minDifference = 0.001;
  let difference = layerA.y - layerB.y;
  if (layerA.y === layerB.y || Math.abs(difference) <= minDifference) {
    difference = layerA.x - layerB.x;
    if (layerA.x === layerB.x || Math.abs(difference) <= minDifference) {
      return 0;
    } else if (layerA.x > layerB.x) {
      return 1;
    } else {
      return -1;
    }
  } else if (layerA.y > layerB.y) {
    return 1;
  } else {
    return -1;
  }
}